import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_current_location_stock_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_code: fromDatatype.VarcharDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  sub_location_code: fromDatatype.VarcharDatatypeInterface;
  serial_no_json: fromDatatype.JsonDatatypeInterface;
  batch_no_json: fromDatatype.JsonDatatypeInterface;
  qty_ledger: fromDatatype.NumericDatatypeInterface;
  qty_physical: fromDatatype.NumericDatatypeInterface;
  qty_available: fromDatatype.NumericDatatypeInterface;
  qty_reserved: fromDatatype.NumericDatatypeInterface;
  qty_display_unit: fromDatatype.NumericDatatypeInterface;
  qty_damaged: fromDatatype.NumericDatatypeInterface;
  qty_rma: fromDatatype.NumericDatatypeInterface;
  qty_ecom_buffer: fromDatatype.NumericDatatypeInterface;
  qty_sales_order_open: fromDatatype.NumericDatatypeInterface;
  qty_purchase_order_open: fromDatatype.NumericDatatypeInterface;
  qty_work_order_open: fromDatatype.NumericDatatypeInterface;
  qty_jobsheet_open: fromDatatype.NumericDatatypeInterface;
  qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  qty_min_level: fromDatatype.NumericDatatypeInterface;
  qty_max_level: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  bin_no_json: fromDatatype.JsonDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
}

export class bl_inv_current_location_stock_balance_RowClass
  implements bl_inv_current_location_stock_balance_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_code: fromDatatype.VarcharDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  sub_location_code: fromDatatype.VarcharDatatypeInterface;
  serial_no_json: fromDatatype.JsonDatatypeInterface;
  batch_no_json: fromDatatype.JsonDatatypeInterface;
  qty_ledger: fromDatatype.NumericDatatypeInterface;
  qty_physical: fromDatatype.NumericDatatypeInterface;
  qty_available: fromDatatype.NumericDatatypeInterface;
  qty_reserved: fromDatatype.NumericDatatypeInterface;
  qty_display_unit: fromDatatype.NumericDatatypeInterface;
  qty_damaged: fromDatatype.NumericDatatypeInterface;
  qty_rma: fromDatatype.NumericDatatypeInterface;
  qty_ecom_buffer: fromDatatype.NumericDatatypeInterface;
  qty_sales_order_open: fromDatatype.NumericDatatypeInterface;
  qty_purchase_order_open: fromDatatype.NumericDatatypeInterface;
  qty_work_order_open: fromDatatype.NumericDatatypeInterface;
  qty_jobsheet_open: fromDatatype.NumericDatatypeInterface;
  qty_reorder_level: fromDatatype.NumericDatatypeInterface;
  qty_min_level: fromDatatype.NumericDatatypeInterface;
  qty_max_level: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  bin_no_json: fromDatatype.JsonDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
}
